import React, { useContext, useState } from 'react';
import Img from 'gatsby-image';
import styled from 'styled-components';
import { GlassMagnifier } from 'react-image-magnifiers';
import { AnchorLink } from 'gatsby-plugin-anchor-links';
import LocaleBlock from './LocaleBlock';
import { breakpoints } from '../styles/Variables';
import { tr } from '../utils/translations';
import expand from '../assets/images/expand-black.svg';
import expandHover from '../assets/images/expand-black-hover.svg';
import close from '../assets/images/close-expanded-black.svg';
import closeHover from '../assets/images/close-expanded-black-hover.svg';
import LocaleContext from './LocaleContext';

const MasterPlanStyles = styled.div`
  position: relative;

  h2 {
    position: absolute;
    left: var(--col1);
    top: 2rem;
    z-index: 1;
    font-size: 1.5rem;
    margin: 0;
  }

  .block {
    position: absolute;
    z-index: 1;
    display: none;

    p {
      margin-top: 0;
    }

    &.phase {
      display: block;
      left: var(--col1);
      top: 4rem;
      text-transform: uppercase;
      font-family: Avenir, sans-serif;
      font-size: var(--fsDetails);

      p {
        margin: 0;
      }
    }
  }

  img {
    max-width: unset;
  }

  .toggleExpanded {
    position: absolute;
    z-index: 1;
    top: 2rem;
    right: 1rem;
    background-color: transparent;
    background-repeat: no-repeat;
    background-size: contain;
    border: none;
    text-indent: -9999px;
    width: 2rem;
    height: 2rem;
    cursor: pointer;
    transition: all 0.5s;
    outline: none;
    background-image: url(${expand});
    border-radius: 0;
  }

  .cta {
    position: absolute;
    left: var(--col1);
    bottom: 3rem;
    background: var(--black);
    color: var(--grey);
    border-style: none;
    font-family: Avenir, sans-serif;
    font-weight: bold;
    font-size: var(--fsButton);
  }

  &.expanded {
    margin-bottom: 100vh; // To avoid losing scroll position
    z-index: 10;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;

    .block.phase {
      top: 1rem;
      left: calc(var(--col1) + 5rem);
    }

    .toggleExpanded {
      position: fixed;
      z-index: 10;
      background-image: url(${close});
    }

    .cta {
      display: none;
    }

    .notice {
      display: block;

      @media (orientation: landscape) {
        display: none;
      }
    }
  }

  .notice {
    position: absolute;
    width: 100%;
    left: 0;
    top: var(--col2);
    font-family: Avenir, sans-serif;
    display: none;
    text-align: center;
  }

  @media (min-width: ${breakpoints.breakLg}) {
    min-height: calc(100vh - var(--navHeight));

    h2 {
      top: 3rem;
      font-size: var(--fsTitle2);
    }

    .cta {
      background: transparent;
      border-style: solid;
      color: var(--black);
      top: 5.5rem;
      bottom: unset;
      font-weight: normal;
    }

    .block {
      display: block;
      top: 3rem;

      &.location {
        left: var(--col6);
      }

      &.airport {
        left: var(--col9);
      }

      &.phase {
        display: none;
      }
    }

    .toggleExpanded {
      display: none;
    }

    .notice {
      display: none;
    }
  }

  @media (max-width: ${breakpoints.breakLg}) {
    height: calc(100vh - var(--navHeight));

    div:not(.block) {
      height: 100%;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
`;

const HandleToggleExpanded = (expanded, setExpanded) => {
  if (expanded) {
    document.body.classList.remove('expanded');
  } else {
    document.body.classList.add('expanded');
  }
  setExpanded(!expanded);
};

export default function MasterPlan({
  title,
  imageWithAlt,
  locationText,
  airportText,
  phaseText,
}) {
  const [expanded, setExpanded] = useState(false);
  const [locale, setLocale] = useContext(LocaleContext);

  return (
    <MasterPlanStyles className={expanded ? 'expanded' : ''}>
      <a id="master-plan">
        {!expanded && <h2>{title}</h2>}
        {expanded && <h2 className="logo">MUSA</h2>}
      </a>
      <GlassMagnifier
        imageSrc={imageWithAlt.asset.fluid.src}
        imageAlt={imageWithAlt.alt}
      />
      <LocaleBlock content={locationText} className="location" />
      <LocaleBlock content={airportText} className="airport" />
      <LocaleBlock content={phaseText} className="phase" />
      <button
        type="button"
        className="toggleExpanded"
        onClick={() => HandleToggleExpanded(expanded, setExpanded)}
      >
        {expanded ? 'Close' : 'Expand'}
      </button>
      <div className="notice">{tr('cta', 'turnPhoneHorizontal', locale)}</div>
      {/* <AnchorLink className="button cta" to="#timeline">
        {tr('cta', 'viewTimeline', locale)}
      </AnchorLink> */}
    </MasterPlanStyles>
  );
}
